import * as THREE from 'three';

const AMBIENT_LIGHT_COLOR = 0xffffff;
const AMBIENT_LIGHT_INTENSITY = 0.3;
const DIRECTIONAL_LIGHT_COLOR = 0xffffff;
const DIRECTIONAL_LIGHT_INTENSITY = 3;

export function initializeLighting(scene: THREE.Scene): THREE.DirectionalLight {
  const ambient = new THREE.AmbientLight(
    AMBIENT_LIGHT_COLOR,
    AMBIENT_LIGHT_INTENSITY,
  );
  scene.add(ambient);

  const directionalLight = new THREE.DirectionalLight(
    DIRECTIONAL_LIGHT_COLOR,
    DIRECTIONAL_LIGHT_INTENSITY,
  );
  directionalLight.castShadow = true;
  scene.add(directionalLight);
  return directionalLight;
}
